(function($, undefined) {
	
	'use strict';

	var toggleRenewSub = function() {
		var t = $(this);

		var data = {
			 "renew": t.attr('data-value'),
			 "ajax": true
		};

		$.ajax({
			url: '/action/updatePerson',
			cache: false,
			data: data,
			success: function (response) {
				console.log('updatePerson : ', response);
				
				window.location.href = window.location.href;
			}
		});
	};
	
	var init = function () {
		$('.toggle-renew-sub-btn').click(toggleRenewSub);
	};
	
	$(window).ready(init);
	
})(jQuery);
